await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/frontend-data-set-web/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

const isLink = function (
	target: string | undefined,
	onClick: Function | null
): boolean {
	return !(target && target !== 'link') && !onClick;
};

export default isLink;
